import mutations from "../mutations";

export default {
  namespaced: true,
  state: {
    epsState: {},
    epsList: [],
    loading: false,
    error: null,
  },
  mutations,
  actions: {
    clearValues({ commit }, { onlyEps }) {
      commit("setState", { key: "epsState", value: {} });

      if (onlyEps) return;

      commit("setState", { key: "epsList", value: [] });
    },
    getEpsList({ state, commit }) {
      commit("setState", { key: "loading", value: true });
      return new Promise((res, rej) => {
        const response = [
          {
            name: "Nueva EPS",
          },
          {
            name: "Famisanar",
          },
          {
            name: "Comfenalco",
          }
        ];
        if (state.nulll) {
          rej("Sorry, error");
          return;
        }
        setTimeout(() => {
          commit("setState", { key: "loading", value: false });
          commit("setState", { key: "epsList", value: response });
          return res(response);
        }, 1000);
      })
    },
  },
};
